<script>
  import axios from "axios";
  import { onMount } from "svelte";
  import { router } from "../../../../core";

  type NewFileCountResponseType = { constructionNewFileCount: number };

  let count: number;

  onMount(() => {
    router.subscribe(updateCount);
  });

  function updateCount() {
    axios
      .get<NewFileCountResponseType>(`/api/ConstructionFile/getNewFileCount`)
      .then((r) => {
        count = r.data.constructionNewFileCount;
      });
  }
</script>

{#if count > 0}
  <span class="nav-badge">{count}</span>
{/if}

<style lang="scss">
  .nav-badge {
    position: relative;
    top: -12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: $warning-color;
    color: $text-reverse-color;
    letter-spacing: 0;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 900;
    min-width: 19px;
    height: 19px;
    line-height: 1;
  }
</style>
